module.exports = __webpack_public_path__ + "static/media/Musculoskeletal Hiking Photo.39cb1f6d.png";